import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppBrandAltSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.696 2c6.406 0 9.611 0 12.058 1.246a11.44 11.44 0 0 1 5 5C46.001 10.693 46 13.898 46 20.305v7.39c0 6.407.001 9.612-1.246 12.059a11.44 11.44 0 0 1-5 5C37.307 46 34.103 46 27.696 46h-7.391c-6.407 0-9.611 0-12.059-1.246a11.44 11.44 0 0 1-5-5C2 37.307 2 34.102 2 27.695v-7.39c0-6.407 0-9.612 1.246-12.059a11.44 11.44 0 0 1 5-5C10.694 1.999 13.898 2 20.305 2z"
            fill="white"
        />
        <path
            d="M36.638 21.295c0-1.09-.241-2.17-.71-3.178a8.3 8.3 0 0 0-2.021-2.694 9.5 9.5 0 0 0-3.025-1.8 10.3 10.3 0 0 0-3.57-.63h-15.39V35h6.29v-5.402h7.544L29.896 35h6.742l-4.911-6.388c1.483-.713 2.722-1.769 3.586-3.057a7.66 7.66 0 0 0 1.325-4.26m-9.325 2.701h-9.1v-5.402h9.1c1.669 0 3.033 1.215 3.033 2.701s-1.364 2.701-3.033 2.701"
            fill="#E80200"
        />
    </svg>
));
RabotaByAppBrandAltSize48Glyph.displayName = 'RabotaByAppBrandAltSize48Glyph';
